var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 12 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M0 12.6667V2C5.47224e-07 1.46957 0.210865 0.96101 0.585937 0.585938C0.96101 0.210865 1.46957 0 2 0H7.33333V0.000651042C7.63193 0.00030924 7.92791 0.0582287 8.20378 0.172526C8.47956 0.286815 8.72994 0.454654 8.94075 0.666016L11.3314 3.05664L11.4089 3.13737C11.5849 3.33057 11.7264 3.55301 11.8268 3.79492C11.9415 4.07114 12.0003 4.36762 12 4.66667V12.6667C12 13.1971 11.7891 13.7057 11.4141 14.0807C11.039 14.4558 10.5304 14.6667 10 14.6667H2C1.46957 14.6667 0.96101 14.4558 0.585937 14.0807C0.210866 13.7057 0 13.1971 0 12.6667ZM8.66667 10C9.03486 10 9.33333 10.2985 9.33333 10.6667C9.33333 11.0349 9.03486 11.3333 8.66667 11.3333H3.33333C2.96514 11.3333 2.66667 11.0349 2.66667 10.6667C2.66667 10.2985 2.96514 10 3.33333 10H8.66667ZM8.66667 7.33333C9.03486 7.33333 9.33333 7.63181 9.33333 8C9.33333 8.36819 9.03486 8.66667 8.66667 8.66667H3.33333C2.96514 8.66667 2.66667 8.36819 2.66667 8C2.66667 7.63181 2.96514 7.33333 3.33333 7.33333H8.66667ZM4.66667 4.66667C5.03486 4.66667 5.33333 4.96514 5.33333 5.33333C5.33333 5.70152 5.03486 6 4.66667 6H3.33333C2.96514 6 2.66667 5.70152 2.66667 5.33333C2.66667 4.96514 2.96514 4.66667 3.33333 4.66667H4.66667ZM10.3893 4L8 1.61068V4H10.3893ZM1.33333 12.6667C1.33333 12.8435 1.40362 13.013 1.52865 13.138C1.65367 13.263 1.82319 13.3333 2 13.3333H10C10.1768 13.3333 10.3463 13.263 10.4714 13.138C10.5964 13.013 10.6667 12.8435 10.6667 12.6667V5.33333H8C7.64638 5.33333 7.30734 5.19276 7.05729 4.94271C6.80724 4.69266 6.66667 4.35362 6.66667 4V1.33333H2C1.82319 1.33333 1.65367 1.40362 1.52865 1.52865C1.40362 1.65367 1.33333 1.82319 1.33333 2V12.6667Z",
          fill: _vm.fill
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }